var _metadata, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEplogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsdc: "http://purl.org/dc/elements/1.1/",
    xmlnscc: "http://creativecommons.org/ns#",
    xmlnsrdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnssvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "37.8125 37.95703125 165.2421875 90.18359375",
    height: 166.09332,
    width: 241.10667,
    xmlSpace: "preserve",
    id: "svg2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata8"
  }, /*#__PURE__*/React.createElement("rdfrdf", null, /*#__PURE__*/React.createElement("ccwork", {
    rdfabout: ""
  }, /*#__PURE__*/React.createElement("dcformat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dctype", {
    rdfresource: "http://purl.org/dc/dcmitype/StillImage"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,166.09333)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.1)",
    id: "g12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    style: {
      fill: "#254aa5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 1522.91,284.645 V 662.836 H 956.031 V 284.645 h 566.879"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    style: {
      fill: "#fff200",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1239.17,621.73 5.41,-16.777 17.59,0.086 -14.28,-10.301 5.51,-16.75 -14.23,10.43 -14.17,-10.43 5.51,16.75 -14.31,10.301 17.59,-0.086 5.38,16.777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    style: {
      fill: "#fff200",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1239.17,369.441 5.41,-16.73 17.59,0.078 -14.28,-10.332 5.51,-16.746 -14.23,10.41 -14.17,-10.41 5.51,16.746 -14.31,10.332 17.59,-0.078 5.38,16.73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    style: {
      fill: "#fff200",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1176.42,604.953 5.39,-16.769 17.6,0.05 -14.25,-10.254 5.5,-16.726 -14.24,10.406 -14.18,-10.406 5.5,16.726 -14.25,10.254 17.6,-0.05 5.33,16.769"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    style: {
      fill: "#fff200",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1130.26,558.645 5.35,-16.766 17.63,0.113 -14.33,-10.32 5.5,-16.723 -14.15,10.422 -14.21,-10.422 5.52,16.723 -14.34,10.32 17.65,-0.113 5.38,16.766"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    style: {
      fill: "#fff200",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1113.21,495.711 5.33,-16.731 17.65,0.079 -14.29,-10.313 5.45,-16.699 -14.14,10.422 -14.2,-10.422 5.55,16.699 -14.35,10.313 17.63,-0.079 5.37,16.731"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    style: {
      fill: "#fff200",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1130.04,432.82 5.4,-16.836 17.56,0.137 -14.27,-10.312 5.54,-16.719 -14.23,10.457 -14.2,-10.457 5.54,16.719 -14.31,10.281 17.59,-0.106 5.38,16.836"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    style: {
      fill: "#fff200",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1176.42,386.531 5.39,-16.781 17.6,0.09 -14.25,-10.281 5.5,-16.739 -14.24,10.399 -14.18,-10.399 5.5,16.739 -14.25,10.281 17.6,-0.09 5.33,16.781"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path30",
    style: {
      fill: "#fff200",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1302.01,604.953 -5.37,-16.769 -17.65,0.05 14.32,-10.254 -5.52,-16.726 14.22,10.406 14.18,-10.406 -5.49,16.726 14.27,10.254 -17.56,-0.05 -5.4,16.769"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32",
    style: {
      fill: "#fff200",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1348.2,558.645 -5.38,-16.766 -17.62,0.113 14.3,-10.32 -5.52,-16.723 14.22,10.422 14.23,-10.422 -5.55,16.723 14.28,10.32 -17.61,-0.113 -5.35,16.766"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    style: {
      fill: "#fff200",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1365.24,495.711 -5.37,-16.731 -17.66,0.079 14.33,-10.313 -5.52,-16.699 14.22,10.422 14.21,-10.422 -5.5,16.699 14.25,10.313 -17.6,-0.079 -5.36,16.731"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    style: {
      fill: "#fff200",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1348.32,432.82 -5.31,-16.836 -17.62,0.137 14.31,-10.312 -5.53,-16.719 14.15,10.457 14.26,-10.457 -5.51,16.719 14.29,10.281 -17.61,-0.106 -5.43,16.836"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38",
    style: {
      fill: "#fff200",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1302.01,386.531 -5.37,-16.781 -17.65,0.09 14.32,-10.281 -5.52,-16.739 14.22,10.399 14.18,-10.399 -5.49,16.739 14.27,10.281 -17.56,-0.09 -5.4,16.781"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40",
    style: {
      fill: "#e9f1f7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1046.45,738.277 v 31.274 c -11.41,9.746 -56.856,29.258 -84.591,35.387 v -22.016 c 31.7,-7.789 71.211,-30.707 84.591,-44.645"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    style: {
      fill: "#e9f1f7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1069.5,691.602 h 26.93 c 0.8,39.464 -31.23,63.894 -35.8,67.433 v -37.601 c 10.27,-16.672 8.87,-29.832 8.87,-29.832"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44",
    style: {
      fill: "#e9f1f7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1136.51,771.031 v -33.945 c 13.53,-14.168 21.66,-25.262 28.1,-45.645 h 28.52 c -7.62,31.164 -25.74,56.633 -56.62,79.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46",
    style: {
      fill: "#e9f1f7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1119.15,752.418 v 30.586 c -26.16,16.918 -77.9,40.109 -129.556,50.891 v -21.934 c 49.646,-12.039 102.426,-37.766 129.556,-59.543"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path48",
    style: {
      fill: "#e9f1f7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1192.47,770.984 v 30.262 c -31.41,19.797 -96.04,47.461 -172.31,63.567 v -21.895 c 73.24,-17.695 128.83,-42.941 172.31,-71.934"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path50",
    style: {
      fill: "#e9f1f7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1212.74,788.367 c -0.02,0.02 -0.06,-32.539 -0.06,-32.539 20.02,-15.898 39.4,-36.832 52.31,-64.387 h 30.27 c -10.37,34.289 -49.12,75.852 -82.52,96.926"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path52",
    style: {
      fill: "#e9f1f7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1274.22,789.82 v 30.274 c -60.04,35.519 -150.02,66.734 -221.5,79.328 v -21.828 c 80.72,-16.196 176.87,-56.09 221.5,-87.774"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path54",
    style: {
      fill: "#e9f1f7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1371.33,691.441 h 31.7 c -22.79,54.606 -79.92,98.379 -106.6,115.039 v -32.117 c 40.41,-29.933 55.35,-51.328 74.9,-82.922"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path56",
    style: {
      fill: "#e9f1f7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1354.71,808.941 v 31.36 c -48.63,29.758 -147.03,74.301 -266.85,97.383 v -22.786 c 91.17,-18.937 207.4,-64.168 266.85,-105.957"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path58",
    style: {
      fill: "#e9f1f7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1474.24,691.441 h 34.69 c -38.46,65.438 -82.46,102.852 -130,133.782 v -32.864 c 35.24,-24.746 72.99,-61.64 95.31,-100.918"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path60",
    style: {
      fill: "#e9f1f7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 939.145,789.059 v 20.679 c -31.192,5.867 -86.043,9.61 -110.145,6.469 v -16.199 c 36.191,1.883 89.48,-4.844 110.145,-10.949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path62",
    style: {
      fill: "#e9f1f7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 804.727,798.527 V 814 C 746.82,807.945 707.102,788.047 684.121,771.074 v -13.308 c 32.809,26.484 78.262,37.445 120.606,40.761"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path64",
    style: {
      fill: "#e9f1f7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 670.738,743.883 0.004,15.058 C 617.473,699.094 684.121,649.25 691.211,644.285 v 20.461 c -37.258,28.16 -32.883,62.481 -20.473,79.137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path66",
    style: {
      fill: "#e9f1f7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 711.379,652.066 v -21.941 c 36.172,-20.02 72.574,-32.676 124.359,-41.953 l -0.371,29.746 c -35.191,2.129 -83.558,12.16 -123.988,34.148"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path68",
    style: {
      fill: "#e9f1f7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 853.023,616.98 -0.156,-30.937 c 30.281,-2.52 58.875,-3.281 74.461,-3.262 v 34.805 c -22.988,-1.543 -65.594,-1.844 -74.305,-0.606"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path70",
    style: {
      fill: "#e9f1f7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 966.879,817.293 v 21.094 c -37.285,7.551 -109.559,13.176 -152.375,9.179 V 831.16 c 56.508,2.082 112.394,-5.137 152.375,-13.867"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path72",
    style: {
      fill: "#e9f1f7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 816.199,528.516 v 33.121 c -55.445,4.914 -140.691,24.269 -193.633,63.125 v -22.09 c 58.055,-43.777 149.872,-68.063 193.633,-74.156"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path74",
    style: {
      fill: "#e9f1f7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 602.473,619.254 v 21.875 C 555.496,685.797 564.668,731.238 595,760.516 v 13.679 C 536.699,721.254 558.059,657.18 602.473,619.254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path76",
    style: {
      fill: "#e9f1f7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 835.68,559.859 v -34.293 c 33.75,-4.746 63.015,-6.269 91.648,-6.269 v 37.848 c -30.879,-0.165 -77.937,1.437 -91.648,2.714"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path78",
    style: {
      fill: "#e9f1f7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 610.715,787.086 v -12.891 c 50.519,37.59 126.277,52.739 179.527,55.625 v 15.754 C 724.297,841.266 648.539,815.992 610.715,787.086"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path80",
    style: {
      fill: "#e9f1f7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 528.516,599.195 v -23.699 c 72.468,-65.363 191.703,-100.949 263.73,-113.371 v 36.934 c -66.367,7.441 -186.293,33.168 -263.73,100.136"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path82",
    style: {
      fill: "#e9f1f7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 997.445,848.348 v 20.82 c -46.836,8.523 -127.761,17.82 -203.55,10.887 v -16.492 c 63.699,4.437 153.609,-3.848 203.55,-15.215"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path84",
    style: {
      fill: "#e9f1f7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 813.574,496.656 v -38.222 c 32.125,-6.426 84.965,-9.414 113.754,-10.469 v 42.598 c -17.148,-0.606 -92.332,3.71 -113.754,6.093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path86",
    style: {
      fill: "#e9f1f7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 769.578,862.027 v 16.028 C 713.242,873.203 612.504,853.141 545.676,807.906 V 794.93 c 65.039,44.289 165.703,63.945 223.902,67.097"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path88",
    style: {
      fill: "#e9f1f7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 527.336,781.727 V 794.93 C 496.762,771.871 421.793,694.129 508.574,595.73 v 23.868 c -19.289,21.562 -65.847,91.406 18.762,162.129"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path90",
    style: {
      fill: "#e9f1f7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1030,882.48 v 21.375 C 973.285,914.988 862.77,924.621 775.879,916.09 V 899.578 C 852.691,905.52 961.957,896.855 1030,882.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path92",
    style: {
      fill: "#e9f1f7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 789.934,431.188 v -40.43 c 42.777,-8.32 96.046,-13.477 137.394,-14.883 v 45.879 c -49.453,0.84 -92.117,3.184 -137.394,9.434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path94",
    style: {
      fill: "#e9f1f7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 766.57,394.586 v 39.121 C 647.645,450.523 516.602,493.844 435.398,573.465 V 548.23 C 531.602,452.398 691.188,408.219 766.57,394.586"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path96",
    style: {
      fill: "#e9f1f7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 479.973,830.809 v -12.727 c 79.504,50.606 188.425,72.359 271.629,79.738 v 16.094 C 671.609,906.98 554.465,879.738 479.973,830.809"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path98",
    style: {
      fill: "#e9f1f7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 415.332,572.672 v 26.008 c -31.129,42.441 -61.672,126.156 45.898,206.316 v 13.086 C 340.422,731.707 370.531,625.977 415.332,572.672"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path100",
    style: {
      fill: "#e9f1f7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 331.914,556.355 V 528.164 C 423.176,409.781 611.609,340.094 728.777,315.406 v 43.223 c -123.101,20.84 -310.144,81.152 -396.863,197.726"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path102",
    style: {
      fill: "#e9f1f7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1064.89,919.793 v 22.187 c -56.1,11.719 -192.445,26.836 -312.527,14.336 v -17.05 c 100.407,8.836 227.114,-1.946 312.527,-19.473"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path104",
    style: {
      fill: "#e9f1f7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 728.105,937.195 v 16.668 C 623.902,943.23 494.527,907.188 418.926,857.789 v -13.211 c 94.976,58.235 221.019,84.277 309.179,92.617"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path106",
    style: {
      fill: "#e9f1f7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 754.23,354.508 v -44.317 c 26.754,-6.816 128.313,-21.347 173.098,-21.699 v 50.801 c -68.348,2.168 -138.156,9.59 -173.098,15.215"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path108",
    style: {
      fill: "#e9f1f7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 398.555,831.16 v 13.418 C 367.973,824.855 223.164,716.133 312.117,559.246 v 31.641 c -55.637,115.652 29.172,199.582 86.438,240.273"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEplogo);
export default __webpack_public_path__ + "static/media/eplogo.b7fe93f0402fd53677719d15d23802cb.svg";
export { ForwardRef as ReactComponent };